"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_mission_waves = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var diveCrew_enemy_sidecar_1 = require("../crew/diveCrew_enemy-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMissionDataWaves_1 = require("./voyageMissionDataWaves");
var voyageMissionEvent_boarded_sidecar_1 = require("./voyageMissionEvent_boarded-sidecar");
var voyageMissionEvent_bomb_sidecar_1 = require("./voyageMissionEvent_bomb-sidecar");
var voyageMissionEvent_breach_sidecar_1 = require("./voyageMissionEvent_breach-sidecar");
var voyageMissionEvent_enemyShip_sidecar_1 = require("./voyageMissionEvent_enemyShip-sidecar");
var voyageMissionEvent_fire_sidecar_1 = require("./voyageMissionEvent_fire-sidecar");
function generator_mission_waves() {
    var mission, wave, ds, numAliens, numBombs, hasAlienShip;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                if (!!voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) return [3 /*break*/, 2];
                return [4 /*yield*/, 0];
            case 1:
                _a.sent();
                return [3 /*break*/, 0];
            case 2:
                mission = voyageGameStatus_sidecar_1.voyageGameStatus.get().currentMission;
                if (mission.waveIdx >= mission.waves.length) {
                    return [3 /*break*/, 10];
                }
                wave = mission.waves[mission.waveIdx];
                ds = common_sidecar_1.common.getUpdateDeltaScaled();
                if (!wave.waitTillClear) return [3 /*break*/, 8];
                numAliens = diveCrew_enemy_sidecar_1.diveCrew_enemy.countEnemies();
                numBombs = voyageCarryable_sidecar_1.voyageCarryable.countBombs();
                hasAlienShip = voyageGameStatus_sidecar_1.voyageGameStatus.get().enemyShip.active;
                console.log('wave info', numAliens, numBombs, hasAlienShip);
                if (!(numAliens > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, 0];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4:
                if (!(numBombs > 0)) return [3 /*break*/, 6];
                return [4 /*yield*/, 0];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6:
                if (!hasAlienShip) return [3 /*break*/, 8];
                return [4 /*yield*/, 0];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8:
                mission.waveTimer -= ds;
                if (mission.waveTimer <= 0) {
                    mission.waveTimer = wave.postWaveTime;
                    mission.waveIdx++;
                    console.log('WAVE', wave.type);
                    if (wave.type === voyageMissionDataWaves_1.EVoyageWaveType.Fire) {
                        voyageMissionEvent_fire_sidecar_1.voyageMissionEvent_fire.run_fire();
                    }
                    else if (wave.type === voyageMissionDataWaves_1.EVoyageWaveType.HullBreach) {
                        voyageMissionEvent_breach_sidecar_1.voyageMissionEvent_breach.run_breach();
                    }
                    else if (wave.type === voyageMissionDataWaves_1.EVoyageWaveType.AlienShip) {
                        voyageMissionEvent_enemyShip_sidecar_1.voyageMissionEvent_enemyShip.run_enemyShip();
                    }
                    else if (wave.type === voyageMissionDataWaves_1.EVoyageWaveType.BoardedByAliens) {
                        voyageMissionEvent_boarded_sidecar_1.voyageMissionEvent_boarded.run_boarded(wave.amount, wave.amount);
                    }
                    else if (wave.type === voyageMissionDataWaves_1.EVoyageWaveType.Bomb) {
                        voyageMissionEvent_bomb_sidecar_1.voyageMissionEvent_bomb.run_bomb(wave.amount, wave.amount);
                    }
                    else if (wave.type === voyageMissionDataWaves_1.EVoyageWaveType.Null) {
                    }
                    else {
                        assert_sidecar_1.assert.failed('unhandled wave type', wave.type);
                    }
                }
                return [4 /*yield*/, 0];
            case 9:
                _a.sent();
                return [3 /*break*/, 0];
            case 10: return [2 /*return*/, 0];
        }
    });
}
exports.generator_mission_waves = generator_mission_waves;
